import module from './module';
import ProfileController from './controllers/ProfileController';
import OrderHistoryService from './services/OrderHistoryService';
import OrderHistoryDetailsDirective from './directives/OrderHistoryDetailsDirective';
import OrderHistoryDirective from './directives/OrderHistoryDirective';
import OrderHistoryHeaderDirective from './directives/OrderHistoryHeaderDirective';
import UserProfileDirective from './directives/UserProfileDirective';

export default module.name;


// WEBPACK FOOTER //
// ./src/modules/profile/index.js